window.theme = window.theme || {};
$(document).ready(function () {
console.log('111');
});

(function($){
  var $ = jQuery = $;

$(function() {
console.log('111');
});

  theme.config = {
    BASE_URL:''
  };


  theme.genie = {
     getCart: function() {
      return $.getJSON('/cart.js');
    },
    _sendAjax: function(params) {
      return $.ajax(params)
          .then(function(data) {
            return data;
          }.bind(this))
    },
    getAddOns: function(url,data) {
      return this._sendAjax({
        type: 'POST',
        url: url,
        data: data,
        dataType:"json",
      });
    },
    addProductToOrder: function(url,data) {
      return this._sendAjax({
        type: 'POST',
        url: url,
        data: data,
        dataType:"json",
      });
    },
    addItemFromForm: function(data) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      });
    },
    _updateCart: function(params) {
      return $.ajax(params)
        .then(function(cart) {
          return cart;
        }.bind(this))
    },
    saveForm: function(data,url) {
      return this._sendAjax({
        type: 'POST',
        url: url,
        data: data,
        dataType: 'json',
        crossDomain: true
      });
    },


    showError: function(el,message){
      el.append('<div class="errors text-center">'+message+'</div>');
      setTimeout(function(){
        el.find('.errors').remove();
      }, 3000);
    },
    setCookie: function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie: function(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },


  }
})(jQuery);

function setValueOnOption(op,id){
  $('#'+id).html(op);
}